import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSalesInvoiceListMutation } from '../../../../store/api/salesinvoice';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
import { usePostSalesInvoicedCountApiMutation, usePostSalesInvoiceListApiMutation } from "../../../../store/api/salesinvoiceAuricApi";
import { useGetSelectedCompanyQuery } from "../../../../store/api/companyapi";

const Maincontent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling, pageSize } = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [salesInvoice, setSalesInvoice] = useState({ sales_invoices: [], total_no_of_records: 0 });
    const [getSalesInvoiceList] = useGetSalesInvoiceListMutation();
    const [salesInvoiceList] = usePostSalesInvoiceListApiMutation();
    const [salesInvoiceCountApi] = usePostSalesInvoicedCountApiMutation();
    // const { data: salesInvoiceCount , isLoading, refetch: refetchSalesInvoiceCount } = useGetSalesInvoiceCountQuery();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [totalCount, settotalCount] = useState(0);
    const [deleteDoc] = useDeleteDocMutation();
    const getcompany = useGetSelectedCompanyQuery();
    const selectedComapny = getcompany?.data?.message?.data?.company.split(" - ")[0];


    const filtersConfig = [
        // { name: 'siNo', label: 'S. No.', width: '6%', type: 'number' },
        { name: 'name', label: 'ID', width: '15%', type: 'text' },
        { name: 'company', label: 'Company', width: '15%', type: 'text' },
        { name: 'fiscal_year', label: 'Fiscal Year', width: '15%', type: 'text' },
        // { name: 'company', label: 'Company', type: 'text', width: '12%' },
        { name: 'status',
            label: 'Status',
            width: '13.7%',
            type: 'select',
            options: [
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Return', label: 'Return' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'Credit Note Issued', label: 'Credit Note Issued' },
                { value: 'Submitted', label: 'Submitted' },
                { value: 'Paid', label: 'Paid' },
                { value: 'Partly Paid', label: 'Partly Paid' },
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Unpaid and Discounted', label: 'Unpaid and Discounted' },
                { value: 'Partly Paid and Discounted', label: 'Partly Paid and Discounted' },
                { value: 'Overdue and Discounted', label: 'Overdue and Discounted' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Internal Transfer', label: 'Internal Transfer' },
            ]
        },
        { name: 'creation', label: 'Created By', type: 'date', width: '12%' },
    ];


    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '6%',
            cellRenderer: (row)=> row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Id",
            name: "Id",
            accessor: "name",
            width: '15%',
            sortable: true,
            visible: true
        },
            {
            header: "Company",
            name: "Company",
            accessor: "company",
            width: '12%',
            sortable: true,
            visible: true,
        },
         {
            header: "Fiscal Year",
            name: "Fiscal Year",
            accessor: "fiscal_year",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '13%',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;
                switch (status) {
                    case 'Draft': color = '#E11D48'; break;
                    case 'Submitted': color = '#6366F1'; break;
                    default: color = '#000000';
                }
                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },

         {
            header: "Date & Time",
            name: "Creation",
            accessor: "creation",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.date) - new Date(b.date)
            // sortFn: (a, b) => parseFloat(a.gst_amount) - parseFloat(b.gst_amount)
        },
    
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            visible: true,
            accessor: "action",
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.id}
                    onView={() => handleView(row.id)}
                    onEdit={() => handleEdit(row.id)}
                    onDelete={() => handleDelete(row.id)}
                />
            )
        }
    ]);


    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);
    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);

    const handleView = (id) => navigate(`/master/budget/view-budget`, { state: { id: id } });
    const handleEdit = (id) => navigate(`/master/budget/edit-budget`, { state: { id: id } });
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Budget?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Budget", name: delSelectedId }).unwrap()
            setDelmessage(`Budget ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Budget!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
           className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "btnsecond border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "btnthird border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
			to: "/master/budget/create-budget",
			iconName: "FiPlus",
			style: { gap: "2px", height: "28px" },
			children: "Create Accounting Dimension Details",
        }
    ];

  const getData = async () => {
  setLoading(true);
  try {



    const filteredSearchInput = Object.entries(filters).reduce(
      (acc, [key, value]) => {
        if (value !== "" && value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    const filtersArray = [];
    //   filtersArray.push(["Budget", "company", "=", selectedComapny]);
    if (filteredSearchInput.name) {
      filtersArray.push(["Budget", "name", "like", `%${filteredSearchInput.name}%`]);
    }
    if (filteredSearchInput.title) {
      filtersArray.push(["Budget", "title", "like", `%${filteredSearchInput.title}%`]);
    }
    if (filteredSearchInput.customer) {
      filtersArray.push(["Budget", "customer", "like", `%${filteredSearchInput.customer}%`]);
    }
    if (filteredSearchInput.status) {
      filtersArray.push(["Budget", "status", "=", filteredSearchInput.status]);
    }
    if (filteredSearchInput.creation) {
      filtersArray.push(["Budget", "posting_date", "=", filteredSearchInput.creation]);
    }
     const formData = new FormData();

        formData.append("doctype", "Budget");
        formData.append(
          "fields",
          JSON.stringify(["`tabBudget`.`name`","`tabBudget`.`owner`","`tabBudget`.`creation`","`tabBudget`.`modified`","`tabBudget`.`modified_by`","`tabBudget`.`_user_tags`","`tabBudget`.`_comments`","`tabBudget`.`_assign`","`tabBudget`.`_liked_by`","`tabBudget`.`docstatus`","`tabBudget`.`idx`","`tabBudget`.`budget_against`","`tabBudget`.`company`","`tabBudget`.`fiscal_year`"])
        );
        formData.append("page_length", pageSize);
        formData.append("start", pageSize * (currentPage - 1));

        if (filtersArray && filtersArray.length > 0) {
          formData.append("filters", JSON.stringify(filtersArray));
        }


    const response = await salesInvoiceList(formData).unwrap();

    const raw = response?.message?.values || [];
    const mapped = raw.map((row, index) => ({
      name: row[0],
      creation: new Date(row[3]).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }),
      company: row[12],
      status: row[9] == 0 ? "Draft" : "Submitted",
      fiscal_year: row[13],
      siNo: index + 1 + pageSize * (currentPage - 1),
    }));

    setSalesInvoice({
      sales_invoices: mapped,
      total_no_of_records: mapped.length,
    });
  } catch (error) {
    console.error("Error fetching new Budgets:", error);
  } finally {
    setLoading(false);
  }
};


    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
            const getcount = async() =>{
                try {
                       const filteredSearchInput = Object.entries(filters).reduce(
                            (acc, [key, value]) => {
                                if (value !== "" && value !== undefined && value !== null) {
                                acc[key] = value;
                                }
                                return acc;
                            },
                            {}
                        );
                         const filtersArray = [];
                            // filtersArray.push(["Budget","company","=",selectedComapny]);
                            if (filteredSearchInput.customer) {
                            filtersArray.push(["Budget", "customer", "=", filteredSearchInput.customer]);
                            }
                            if (filteredSearchInput.status) {
                            filtersArray.push(["Budget", "status", "=", filteredSearchInput.status]);
                            }

                    const formData = new FormData();
                    formData.append("doctype", "Budget");

                    formData.append("filters", JSON.stringify(filtersArray));
                    

                    const responsecount = await salesInvoiceCountApi(formData);
                    settotalCount(responsecount.data.message)
                } catch (error) {
                    console.log("check error msg",error);
                }
            }
            getcount()
            getData();
    }, [selectedComapny, currentPage, filters, pageSize, screenHeight, screenScaling]);



    console.log("salesInvoice.sales_invoicessalesInvoice.sales_invoicessalesInvoice.sales_invoices",salesInvoice.sales_invoices);

    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Accounting Dimension Details" },
                    { label: "Accounting Dimension Details List", style: { color: '#4b002b' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Budget"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "id","customer","status","date", "action"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={salesInvoice.sales_invoices}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={totalCount}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Budget"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Maincontent;